export const calculateProgress = (claimedInData: number, claimedOutData: number) => {
  if (!claimedInData && !claimedOutData)
    return {
      sent: 0,
      received: 0
    };

  const progress = claimedInData + claimedOutData;
  const claimedIn = (100 * claimedInData) / progress;
  const claimedOut = (100 * claimedOutData) / progress;

  return {
    sent: claimedOut,
    received: claimedIn
  };
};
